module.exports = __webpack_public_path__ + "static/media/Insight.c0e245e6.png";